import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { Framework } from '@trustero/trustero-api-web/lib/model/framework_pb'
import { StyledDropdownToggle } from '../../../Reusable/StandardDropdown/StandardDropdown.styles'
import { Spinner } from '../../../../Throbber'
import { CountChip } from '../../../Reusable/Chips/BasicChip'
import { usePolicyFrameworks } from './Dropdowns.hooks'

export const PolicyFrameworksDropdown = ({
  id,
}: {
  id: string
}): JSX.Element => {
  const { data: frameworks, isLoading } = usePolicyFrameworks(id)

  if (isLoading || !frameworks) {
    return (
      <Dropdown.Toggle as={StyledDropdownToggle}>
        Criteria
        <Spinner as="span" size="s" color="primary" />
      </Dropdown.Toggle>
    )
  }

  const cfs = frameworks.getItemsList() || []

  return (
    <Dropdown id={`${id}-frameworks-dropdown`} drop="down" autoClose="outside">
      <>
        <Dropdown.Toggle as={StyledDropdownToggle}>
          Criteria
          <CountChip
            as="span"
            inline
            ml="xxs"
            color="white"
            bg="fill.tertiary.dark"
          >
            {cfs.length}
          </CountChip>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <>
            {cfs.map((framework: Framework) => (
              <Dropdown.Item
                key={framework.getModelId()}
                eventKey={framework.getModelId()}
                onClick={(e) => {
                  e.preventDefault()
                }}
              >
                {framework.getName()}
              </Dropdown.Item>
            ))}
          </>
        </Dropdown.Menu>
      </>
    </Dropdown>
  )
}
